<template>
  <!-- Navigation now lives in the single app rail (layout/private.vue);
       this is a pass-through that renders the active section full-width. -->
  <div class="h-full overflow-hidden">
    <router-view class="h-full overflow-hidden" />
  </div>
</template>

<script>
export default {
  name: "index",
  // Props kept for backward-compat with files/index.vue & manage/index.vue,
  // which still pass :sidebar-links and title. Navigation is rendered by the
  // single app rail in layout/private.vue, so they are no longer consumed here.
  props: {
    sidebarLinks: {
      type: Array,
      default: () => [],
    },
    title: {
      type: String,
      default: "",
    },
  },
};
</script>
